import { createBrowserRouter } from 'react-router-dom';

// Layouts
import FrontLayout from './layouts/FrontLayout';


// Templates & Pages
import HomeSection from "./Components/template/HomeSection";
import NotFound from './Components/page/NotFound';
import About from './Components/page/About';
// import Blog from './Components/page/Blog';

// import PostDetail from "./Components/page/PostDetail";
// import PostList from './Components/page/';

import AISection from './Components/page/AISection';
import Contact from './Components/page/Contact';
// import CourseCard from './Components/page/CourseCard';
import CourseDetail from './Components/page/CourseDetail';
import CourseList from './Components/page/CourseList';
import Lesson from './Components/page/Lesson';
import Products from './Components/page/Products';
import Payment from './Components/page/PaymentPage';
import ZarinpalCallback from './Components/page/ZarinpalCallback';

// Auth Components
import Login from './Components/Auth/Login';
import ForgotPassword from './Components/Auth/ForgotPassword';
import ResetPassword from './Components/Auth/ResetPassword';
import SignUp from './Components/Auth/SignUp';
import PrivateRoute from './Components/Auth/PrivateRoute';

// Dashboard Components
import Dashboard from './Components/Dashboard/Dashboard';
import HomeDashboard from './Components/Dashboard/HomeDashbord';
import Profile from './Components/Dashboard/Profile';
import Settings from './Components/Dashboard/Settings';
import UserOrders from './Components/Dashboard/UserOrders';

// User dashboard courses
import UserCourses from "./Components/Dashboard/Course/UserCourses"; // مسیر کامپوننت‌ها
import UserCourseDetail from "./Components/Dashboard/Course/UserCourseDetail";


// Admin Panel Components
import AdminPanel from './Components/AdminPanel/AdminPanel';
import AdminDashboard from './Components/AdminPanel/AdminDashboard';
import SiteSettings from './Components/AdminPanel/SiteSettings';

// User Management
import UserManagement from './Components/AdminPanel/UserManagement/UserManagement';
import UserList from './Components/AdminPanel/UserManagement/UserList';
import AddUser from './Components/AdminPanel/UserManagement/AddUser';
import EditUser from './Components/AdminPanel/UserManagement/EditUser';

// Course Management
import CourseManagement from './Components/AdminPanel/CourseManagement/CourseManagement';
import AddCourse from './Components/AdminPanel/CourseManagement/AddCourse';
import EditCourse from './Components/AdminPanel/CourseManagement/EditCourse';
import CourseListManagement from './Components/AdminPanel/CourseManagement/CourseList';
import CourseBuyers from './Components/AdminPanel/CourseManagement/CourseBuyers';
import AllCourseBuyers from './Components/AdminPanel/CourseManagement/AllCourseBuyers';

// Order Management Components
import OrderManagement from './Components/AdminPanel/OrderManagement/OrderManagement';
import OrderListManagement from './Components/AdminPanel/OrderManagement/OrderList';
import AddOrder from './Components/AdminPanel/OrderManagement/EditOrder';
import EditOrder from './Components/AdminPanel/OrderManagement/EditOrder';

// Comment Management Components
import CommentManagement from './Components/AdminPanel/CommentManagement/CommentManagement';
import CommentListManagement from './Components/AdminPanel/CommentManagement/CommentList';
import EditComment from './Components/AdminPanel/CommentManagement/EditComment';

// Post Management Components
import BlogManagement from './Components/AdminPanel/BlogManagement/BlogManagement';
import BlogListManagement from './Components/AdminPanel/BlogManagement/Posts/PostList';
import AddPost from './Components/AdminPanel/BlogManagement/Posts/AddPost';
import EditPost from './Components/AdminPanel/BlogManagement/Posts/EditPost';

// Category Management Components
import CategoryList from './Components/AdminPanel/BlogManagement/Categories/CategoryList';
import AddCategory from './Components/AdminPanel/BlogManagement/Categories/AddCategory';
import EditCategory from './Components/AdminPanel/BlogManagement/Categories/EditCategory';

// Tag Management Components (optional)
import TagList from './Components/AdminPanel/BlogManagement/Tags/TagList';
import AddTag from './Components/AdminPanel/BlogManagement/Tags/AddTag';
import EditTag from './Components/AdminPanel/BlogManagement/Tags/EditTag';


import LogManagement from './Components/AdminPanel/LogManagement/LogManagement';
import Home from './Components/page/Home';
import ArticlesPage from './Components/page/ArticlesPage';
import TaggedArticlesPage from './Components/page/TaggedArticlesPage';
import SingleArticle from './Components/page/SingleArticle';

import ConsultationPage from './Components/page/consultations/ConsultationPage';
import ConsultationCallback  from './Components/page/consultations/Components/ConsultationCallback';
import ConsultationSuccess  from './Components/page/consultations/Components/ConsultationSuccess';
import ConsultationFailed  from './Components/page/consultations/Components/ConsultationFailed';

// Order Management Components
import ConsultationManagement from './Components/AdminPanel/ConsultationManagement/ConsultationManagement';
import ConsultationListManagement from './Components/AdminPanel/ConsultationManagement/ConsultationListManagement';
import EditConsultation from './Components/AdminPanel/ConsultationManagement/EditConsultation';


export const router = createBrowserRouter([
  {
    path: "/",
    element: <FrontLayout />,
    errorElement: <NotFound />,
    children: [
      {
        index: true,
        element: <>
          <Home />
          {/* <HomeSection toggle={true} /> */}
          {/* <AISection /> */}
        </>
      },
      {
        path: "consultation",
        element: <ConsultationPage />
      },
      {
        path: "consultation/verify",
        element: <ConsultationCallback  />
      },
      {
        path: "consultation/success",
        element: <ConsultationSuccess  />
      },
      {
        path: "consultation/failed",
        element: <ConsultationFailed   />
      },
      {
        path: "about",
        element: <About />
      },
      {
        path: "contact",
        element: <Contact />
      },
      // {
      //   path: "blog",
      //   element: <Blog />
      // },
      {
        path: "courses",
        element: <CourseList />, //  Render CourseList directly at /courses
        index: true,
      },
      {
        path: "courses/:id",       //  Corrected:  Relative path for course details
        element: <CourseDetail />,
      },
      {
        path: "courses/:courseId/lesson/:lessonId",  // Corrected: Relative path
        element: <Lesson />,
      },
      {
        path: "blog",
        element: <ArticlesPage />
      },
      // {
      //   path: "/blog/category/:categoryId",
      //   element: <ArticlesPage />
      // }, 
      {
        path: "/blog/category/:categorySlug",
        element: <ArticlesPage />
      },
      {
        path: "/blog/posts/:slug",
        element: <SingleArticle />
      },

      {
        path: "/blog/tags/:tag",
        element: <TaggedArticlesPage />
      },
      {
        path: "ai",
        element: <AISection />
      },
      {
        path: "products",
        element: <Products />
      },
      {
        path: "forgot-password",
        element: <ForgotPassword />
      },
      {
        path: "reset-password/:resetToken",
        element: <ResetPassword />
      },
      {
        path: "login",
        element: <Login />
      },
      {
        path: "signup",
        element: <SignUp />
      },
      {
        path: "dashboard/*",
        element: (
          <PrivateRoute roles={["user", "admin"]}>
            <Dashboard />
          </PrivateRoute>
        ),
        children: [
          { index: true, element: <HomeDashboard /> },
          { path: "profile", element: <Profile /> },
          { path: "orders", element: <UserOrders /> },
          { path: "settings", element: <Settings /> },
          {
            path: "courses",
            element: <UserCourses />, // مسیر برای لیست دوره ها
          },
          {
            path: "courses/:courseId",
            element: <UserCourseDetail />, // مسیر برای جزئیات دوره
          },
          {
            path: "payment/:id",
            element: <Payment />,
          },
          {
            path: "payment/callback",       
            element: <ZarinpalCallback />,
          },
        ]
      },
      {
        path: "*",
        element: <NotFound />
      }
    ]
  },
  {
    path: "admin",
    element: (
      <PrivateRoute roles={["admin"]}>
        <AdminPanel />
      </PrivateRoute>
    ),
    children: [
      {
        index: true,
        element: <AdminDashboard />
      },
      {
        path: "users",
        children: [
          { index: true, element: <UserManagement /> },
          { path: "list", element: <UserList /> },
          { path: "add", element: <AddUser /> },
          { path: "edit/:id", element: <EditUser /> }
        ]
      },
      {
        path: "courses",
        children: [
          { index: true, element: <CourseManagement /> },
          { path: "list", element: <CourseListManagement /> },
          { path: "add", element: <AddCourse /> },
          { path: "edit/:id", element: <EditCourse /> },
          { path: "buyers/:courseId", element: <CourseBuyers /> },
          { path: "all-buyers", element: <AllCourseBuyers /> }
        ]
      },
      {
        path: "orders",
        children: [
          { index: true, element: <OrderManagement /> },
          { path: "list", element: <OrderListManagement /> },
          { path: "add", element: <AddOrder /> },
          { path: "edit/:id", element: <EditOrder /> }
        ]
      },
      {
        path: "consultations",
        children: [
          { index: true, element: <ConsultationManagement /> },
          { path: "list", element: <ConsultationListManagement /> },         
          { path: "edit/:id", element: <EditConsultation /> }
        ]
      },
      {
        path: "comments",
        children: [
          { index: true, element: <CommentManagement /> },
          { path: "list", element: <CommentListManagement /> },
          { path: "edit/:id", element: <EditComment /> }
        ]
      },
      {
        path: "blog",
        children: [
          { index: true, element: <BlogManagement /> },
          { path: "posts/add", element: <AddPost /> },
          { path: "posts", element: <BlogListManagement /> },
          { path: "posts/edit/:id", element: <EditPost /> },

          // مسیرهای جدید برای مدیریت دسته‌بندی‌ها
          { path: "categories", element: <CategoryList /> },
          { path: "categories/add", element: <AddCategory /> },
          { path: "categories/edit/:id", element: <EditCategory /> },

          // مسیرهای جدید برای مدیریت تگ‌ها (اختیاری)
          { path: "tags", element: <TagList /> },
          { path: "tags/add", element: <AddTag /> },
          { path: "tags/edit/:id", element: <EditTag /> }

        ]
      },
      {
        path: "logs",
        element: <LogManagement />
      },
      {
        path: "settings",
        element: <SiteSettings />
      }
    ]
  }
], {
  future: {
    v7_startTransition: true,
    v7_relativeSplatPath: true,
    v7_fetcherPersist: true,
    v7_normalizeFormMethod: true,
    v7_partialHydration: true,
    v7_skipActionErrorRevalidation: true,
  },
});